export default __webpack_public_path__ + "static/sales-bulk-assign-ca3065863a88b5eafc330ec4885f1206.mp4";